document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('search-input');
  const searchResults = document.getElementById('search-results');
  let debounceTimer;

  searchInput.addEventListener('input', function () {
    const query = searchInput.value.trim();
    clearTimeout(debounceTimer);
   // Set new debounce timer
    debounceTimer = setTimeout(function () {
    if (query.length > 0) {
      // fetch(`/search/suggest.json?q=${query}&resources[type]=product,collection,article,page`)
            fetch(`/search/suggest.json?q=${query}&resources[type]=product,collection`)

        .then(response => response.json())
        .then(data => {
                    displayResults(data.resources.results.products, data.resources.results.collections,query);

          // displayResults(data.resources.results.products, data.resources.results.collections, data.resources.results.pages, data.resources.results.articles,query);
        });
    } else {
      searchResults.innerHTML = '';
       hideResults(); // Hide results if query is empty
    }
        }, 0); // 2000 milliseconds = 2 seconds
  });

  function displayResults(products, collections,query) {
    searchResults.innerHTML = '';
    searchResults.style.display = 'block';
      searchResults.innerHTML = `<p style="text-align:left;margin:10px;color: black;">Hit "Enter" to search for "${query}"</p><hr style="max-width: 100pc;margin:0!important;"/>`;

    // Display collections as chips
    if (collections.length > 0) {
      const collectionsContainer = document.createElement('div');
      collectionsContainer.classList.add('search-collections');
      collections.forEach(collection => {
        const collectionElement = document.createElement('a');
        collectionElement.classList.add('search-chip');
        collectionElement.href = collection.url;
        collectionElement.textContent = collection.title;
        collectionsContainer.appendChild(collectionElement);
      });
      searchResults.appendChild(collectionsContainer);
    }

    // Display pages as chips
    // if (pages.length > 0) {
    //   const pagesContainer = document.createElement('div');
    //   pagesContainer.classList.add('search-pages');
    //   pages.forEach(page => {
    //     const pageElement = document.createElement('a');
    //     pageElement.classList.add('search-chip');
    //     pageElement.href = page.url;
    //     pageElement.textContent = page.title;
    //     pagesContainer.appendChild(pageElement);
    //   });
    //   searchResults.appendChild(pagesContainer);
    // }

    // Display articles as chips

    // if (articles.length > 0) {
    //   const articlesContainer = document.createElement('div');
    //   articlesContainer.classList.add('search-articles');
    //   articles.forEach(article => {
    //     const articleElement = document.createElement('a');
    //     articleElement.classList.add('search-chip');
    //     articleElement.href = article.url;
    //     articleElement.textContent = article.title;
    //     articlesContainer.appendChild(articleElement);
    //   });
    //   searchResults.appendChild(articlesContainer);
    // }

    // Display products as a grid
    if (products.length > 0) {
      const productsContainer = document.createElement('div');
      productsContainer.classList.add('search-products-grid');

      products.forEach(product => {
        const productElement = document.createElement('div');
        productElement.classList.add('search-result-item');
        
        const discount = product.compare_at_price && product.compare_at_price > product.price ? Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100) : 0;

        productElement.innerHTML = `
          <div class="product-image">
            <a href="${product.url}">
              <img src="${product.image}" alt="${product.title}" />
              ${discount > 0 ? `<span class="discount-label">${discount}% OFF</span>` : ''}
            </a>
          </div>
          <div class="product-details">
            <a href="${product.url}">
              <p class="product-title">${product.title}</p>
              <p class="product-price">
              <span >${product.price ? `<span class="price">£${(product.price)}</span>` : ''}
                ${product.compare_at_price_max && product.compare_at_price_max > 0 ? `£<span class="compare-price">${(product.compare_at_price_max)}</span>` : ''}</span>
               
              </p>
            </a>
          </div>
        `;
        productsContainer.appendChild(productElement);
      });

      searchResults.appendChild(productsContainer);
        // View All button
      const viewAllContainer = document.createElement('div');
      viewAllContainer.classList.add('view-all-container');

      const totalCount = products.length;
      const viewAllButton = document.createElement('a');
      viewAllButton.href = `/search?q=${query}`;
      viewAllButton.classList.add('view-all-button');
      // viewAllButton.textContent = `View All (${totalCount})`;
      viewAllButton.textContent = `View All`;
      viewAllContainer.appendChild(viewAllButton);
      searchResults.appendChild(viewAllContainer);
      
    
    } else  {
      searchResults.innerHTML = '<p style="text-align:center;margin:10px;color: black;">Oops!No matches found.Try a different search.</p>';
    }
  }

  function formatCurrency(price) {
    return new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(price / 100);
  }


  function hideResults() {
    // Hide search results container
    searchResults.style.display = 'none';
  }
});
